import { ValueFunction } from '../../index';

function divideMethod({a = null, b = null}) {
  if (a !== null && b !== null) {
    return a / b;
  } else {
    return null;
  }
}

export const divide = new ValueFunction(
  divideMethod,
  {
    label: 'Divide Two Series',
    description: 'a / b',
    parameters: [
      {'name': 'a', 'type': 'number'},
      {'name': 'b', 'type': 'number'},
    ],
    maxLength: 2
  }
);